// extracted by mini-css-extract-plugin
export default {"actions":"Home_actions__qCaG6","contact":"Home_contact__BWmvO"};